<template>
  <v-dialog v-model="isVisible" persistent max-width="600px">
    <v-card>
      <div class="validationDialogWrapper">
        <div class="iconWrapper">
          <img src="../../../../assets/images/warning-icon.png" alt="warning-icon" />
        </div>
        <div class="messageWrapper">
          Following <span>{{ inValidPatients.length }} patients will be skipped</span> as they don't
          have a valid {{ commMode === "sms" ? "mobile" : "email" }}
        </div>
        <div class="patientList">
          <div class="patient" v-for="patient in inValidPatients" :key="patient.name">
            <div class="name">{{ patient.name }}</div>
            <div class="value">{{ patient.value }}</div>
            <div class="errorText">{{ patient.errorText }}</div>
          </div>
        </div>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" text @click="_close">
          Dismiss
        </v-btn>
        <v-btn v-if="validPatients.length" color="primary" text @click="_confirm">
          Continue
        </v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar">
        {{ notification }}
        <template v-slot:action="{ attrs }">
          <v-btn color="pink" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </v-dialog>
</template>
<script>
  /* eslint-disable */
  import { ApiCalls } from "../../../../api-calls";
  import HelperMethods from '../../../../utils/helper-methods';

  export default {
    name: "CommValidationDialog",
    props: {
      isVisible: {
        type: Boolean,
        default: false
      },
      commMode: {
        type: String,
        default: "sms"
      },
      selectedPatients: {
        type: Array,
        default: null
      }
    },
    data: () => ({
      snackbar: false,
      notification: "",
      validPatients: [],
      inValidPatients: []
    }),

    watch: {
      isVisible(val) {
        if (val) {
          this._validate();
        }
      }
    },

    created() { },

    methods: {
      _validate() {
        if (this.commMode === "sms") {
          // SMS Mode
          // Filter by valid numbers
          this.validPatients = this.selectedPatients.filter(p => p.hasValidNumber);
          this.inValidPatients = this.selectedPatients
            .filter(p => !p.hasValidNumber)
            .map(p => {
              const formattedPatient = {
                isSelectable: true,
                isSelected: true,
                id: p.id,
                name: `${p.first_name} ${p.last_name}`,
                value: "",
                errorText: null
              };
              if (p.phone && p.phone.length) {
                formattedPatient.value = p.phone;
                formattedPatient.errorText = "Invalid mobile number";
              } else {
                formattedPatient.isSelectable = false;
                formattedPatient.isSelected = false;
                formattedPatient.errorText = "No mobile number";
              }
              return formattedPatient;
            });
        } else {
          // Email Mode
          // Filter by valid email
          this.validPatients = this.selectedPatients.filter(p => this._validateEmail(p.email));
          this.inValidPatients = this.selectedPatients
            .filter(p => !this._validateEmail(p.email))
            .map(p => {
              const formattedPatient = {
                name: `${p.first_name} ${p.last_name}`,
                value: "",
                errorText: null
              };
              if (p.email && p.email.length) {
                formattedPatient.value = p.email;
                formattedPatient.errorText = "Invalid email";
              } else {
                formattedPatient.errorText = "No email";
              }
              return formattedPatient;
            });
        }
        if (this.validPatients.length === this.selectedPatients.length) {
          // All selected patients are valid
          // So automatically confirm
          this._confirm();
        }
      },

      _confirm() {
        this.$emit("confirm-selection", this.validPatients);
      },

      _validateEmail(email) {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
      },

      async _queryMobileNumber() {
        const landlineNumberPatients = this.inValidPatients.filter(p => p.isSelected);
        try {
          for (const patient of landlineNumberPatients) {
            const payload = {
              "FlowID": "FW37e954eb9a79301030a917945bc8a0ac",
              "ToPhoneNumbers": HelperMethods.prependAreaCodeIfRequired(patient.value),
              "FlowPhoneNumber": "+17088872527",
              "FlowParameters": [
                {
                  "Parameter": "guarantorID",
                  "ParameterValue": patient.id,
                }]
            };
            ApiCalls.executeFlow(payload);
          }
        }
        catch (error) {

        }
      },

      _close() {
        this.$emit("on-close");
      }
    }
  };
</script>

<style lang="scss" scoped>
  .v-overlay.v-overlay--active.theme--dark {
    z-index: 200 !important;
  }

  .validationDialogWrapper {
    display: flex;
    padding: 3rem;
    justify-content: center;
    flex-direction: column;
    align-items: center;

    .iconWrapper {
      img {
        width: 100px;
      }
    }

    .messageWrapper {
      padding-top: 15px;
      font-size: 1.1rem;

      span {
        color: rgb(255, 187, 0);
        font-weight: 600;
      }
    }

    .patientList {
      margin-top: 15px;
      width: 100%;
      max-height: 250px;
      overflow-y: scroll;

      .patient {
        width: 100%;
        margin: 2px 0;
        border: 1px solid rgb(179, 179, 179);
        border-radius: 4px;
        padding: 4px 15px;
        display: flex;
        justify-content: flex-start;

        .checkbox {
          flex: 1;
          margin-top: 0;
          padding-top: 0;
          align-items: center;
        }

        .name {
          flex: 5;
          display: flex;
          align-items: center;
          justify-content: flex-start;
        }

        .value {
          flex: 4;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .errorText {
          flex: 4;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-left: 15px;
          font-size: 0.8rem;
          font-weight: 600;
          background-color: crimson;
          color: #fff;
          padding: 3px 15px;
        }
      }
    }
  }
</style>
